export const PATIENT_CLOSE_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
/**
 * OneTrust consent group that gates Pendo analytics (performance cookies).
 * Pendo is only initialized/tracked when the visitor has opted in to this group.
 */
export const PENDO_CONSENT_GROUP = 'C0002';
/** Event dispatched on `window` by the OneTrust SDK when consent changes. */
export const ONETRUST_GROUPS_UPDATED_EVENT = 'OneTrustGroupsUpdated';
